'use strict';

var $ = require('jquery');
var basePage = require('../pages/base-page.js');
var fullScreenGallery = require('../components/full-screen-gallery.js');
var tagManager = require('../utils/tagManager.js');
var contactDealer = require('../components/contact-dealer.js');
var contactDealerButtonByPhone = require('../components/contact-dealer-button.js');

var classNames = {
	vfsUsedDetailsPage: 'vfs-used-details-page',
	buyingConfidence: 'vfs-used-details-page__dealer__buying-confidence',
	linkList: 'link-list',
	disclaimerReveal: 'vfs-used-details-page__disclaimer-reveal',
	disclaimerIcon: 'vfs-used-details-page__disclaimer-icon'
};

function setVanDealerClick($context){
	var $dealerLink = $context.findByBem(classNames.buyingConfidence, 'link');
	$dealerLink.on('click.vfsUsedDetails', function(e){
		e.preventDefault();
		var $container = $context.findByBem(classNames.buyingConfidence);

		var $text = $container.findByBem(classNames.buyingConfidence, 'text');
		var $link = $container.findByBem(classNames.linkList, 'item');

		if ($text.hasBemClass(classNames.buyingConfidence, 'text', 'expanded') && $link.hasBemClass(classNames.linkList, 'item', 'expanded')){
			$text.removeBemClass(classNames.buyingConfidence, 'text', 'expanded').slideUp('fast');
			$link.removeBemClass(classNames.linkList, 'item', 'expanded');
		}
		else{
			$text.addBemClass(classNames.buyingConfidence, 'text', 'expanded').slideDown('fast');
			$link.addBemClass(classNames.linkList, 'item', 'expanded');
		}
	});
}

function setPhoneInfoClick($context) {
	var $icon = $context.findByBem(classNames.disclaimerIcon);
	var $disclaimer = $context.findByBem(classNames.disclaimerReveal);

	$icon.on('click', function(e) {
		e.preventDefault();
		$disclaimer.slideToggle();
	});
}

function pushVehicleIdToDataLayer() {
	var $page = $.findByBem(classNames.vfsUsedDetailsPage);
	var vehicleId = $page.data('vehicle-id');

	tagManager.pushToDataLayer({
		'vehicleId' : vehicleId
	});
}

basePage.init = function() {
	basePage.initBasePage();

	var $context = $('#vfsUsedDetailsPage');

	fullScreenGallery.init($context);
	setVanDealerClick($context);
	setPhoneInfoClick($context);
	pushVehicleIdToDataLayer();
	
	contactDealer.init();
	contactDealerButtonByPhone.init();
};

module.exports = basePage;